module.exports = __webpack_public_path__ + "static/media/briefcase.5d2be502.svg";